/**
 * Google Drive 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <GoogleDriveIcon className="w-8 h-8" />
 * <GoogleDriveIcon className="w-12 h-12" />
 * ```
 */
export function GoogleDriveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Google Drive icon"
      role="img"
    >
      <title>Google Drive</title>
      <g id="Google Drive">
        <g id="Vector">
          <path
            d="M4.11684 24.9263L5.35166 27.0577C5.60825 27.5064 5.97709 27.859 6.41008 28.1154L10.8202 20.4872H2C2 20.984 2.12829 21.4808 2.38488 21.9295L4.11684 24.9263Z"
            fill="#0066DA"
          />
          <path
            d="M16 11.5128L11.5899 3.88462C11.1569 4.14103 10.7881 4.49359 10.5315 4.94231L2.38488 19.0449C2.13301 19.4839 2.00034 19.9811 2 20.4872H10.8202L16 11.5128Z"
            fill="#00AC47"
          />
          <path
            d="M25.5899 28.1154C26.0229 27.859 26.3917 27.5064 26.6483 27.0577L27.1615 26.1763L29.6151 21.9295C29.8717 21.4808 30 20.984 30 20.4872H21.1792L23.0561 24.1731L25.5899 28.1154Z"
            fill="#EA4335"
          />
          <path
            d="M16 11.5128L20.4101 3.88462C19.9771 3.62821 19.48 3.5 18.9668 3.5H13.0332C12.52 3.5 12.0229 3.64423 11.5899 3.88462L16 11.5128Z"
            fill="#00832D"
          />
          <path
            d="M21.1792 20.4872H10.8202L6.41008 28.1154C6.84307 28.3718 7.34021 28.5 7.85338 28.5H24.1466C24.6598 28.5 25.1569 28.3558 25.5899 28.1154L21.1792 20.4872Z"
            fill="#2684FC"
          />
          <path
            d="M25.5418 11.9936L21.4685 4.94231C21.2119 4.49359 20.8431 4.14103 20.4101 3.88462L16 11.5128L21.1792 20.4872H29.984C29.984 19.9904 29.8557 19.4936 29.5991 19.0449L25.5418 11.9936Z"
            fill="#FFBA00"
          />
        </g>
      </g>
    </svg>
  );
}
